function assertFunction(value, methodName, label) {
  if (typeof value !== 'function') {
    throw new Error(`[live/ports] ${label} is missing required method: ${methodName}`)
  }
}

/**
 * Shared UI contract for binding provider-specific video handles into provider-neutral tiles.
 *
 * @typedef {object} VideoBinderPort
 * @property {React.ComponentType<{ participant: object, videoHandle: *, className?: string }>} [AttachmentComponent]
 * @property {(participant: object) => string} getRenderKey
 * @property {(params: { videoHandle: *, element: HTMLElement, participant: object }) => void | Promise<void>} bindVideo
 * @property {(params: { element: HTMLElement, participant: object }) => void | Promise<void>} unbindVideo
 */

/**
 * @param {unknown} value
 * @param {string} [label='VideoBinderPort']
 * @returns {VideoBinderPort}
 */
export function assertVideoBinderPort(value, label = 'VideoBinderPort') {
  assertFunction(value?.getRenderKey, 'getRenderKey', label)
  assertFunction(value?.bindVideo, 'bindVideo', label)
  assertFunction(value?.unbindVideo, 'unbindVideo', label)

  return value
}
